document.addEventListener("DOMContentLoaded", function () {
    let lastScrollTop = 0;
    const delta = 5;

    const global = document.getElementById("global");
    const header = document.getElementById("header");
    const navigation = document.getElementById("navigation");

    if (!header) return;

    let headerHeight = header.offsetHeight;
    let stickyHeight = navigation ? navigation.offsetHeight : 0;

    window.addEventListener("scroll", function () {
        let st = window.scrollY || document.documentElement.scrollTop;
        stickyHeight = navigation ? navigation.offsetHeight : 0;

        if (st > headerHeight + 10) {
            global.classList.add("header-sticky");
            //global.style.paddingTop = `${headerHeight}px`;
            navigation.style.top = `-${stickyHeight + 14}rem`;

            if (Math.abs(lastScrollTop - st) <= delta) return;

            if (st > lastScrollTop && st > headerHeight) {
                navigation.style.transform = "translateY(0)";
            } else if (st + window.innerHeight < document.body.scrollHeight) {
                navigation.style.transform = `translateY(${stickyHeight + 15}rem)`;
            }
        } else {
            global.classList.remove("header-sticky");
            global.style.paddingTop = "";
            navigation.style.top = "";
            navigation.style.transform = "";
        }

        lastScrollTop = st;
    });

    window.addEventListener("resize", function () {
        headerHeight = header.offsetHeight;
        stickyHeight = navigation ? navigation.offsetHeight : 0;
    });
});
